import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinvimannagar() {



const cardData = {
  keyword: " Cab Service in Viman Nagar ",

"headingDescription": "SRS Cab Service offers Cab Service in Viman Nagar, providing reliable, comfortable, and efficient transportation for daily commuting, airport transfers, and local travel. Our well-maintained vehicles, professional drivers, and prompt service ensure a smooth and hassle-free journey across Viman Nagar and Pune city. Ideal for business trips, airport pickups and drops, and outstation travel, SRS Cab Service delivers flexible booking options, transparent pricing, and 24/7 customer support for a convenient and stress-free travel experience.",
"topPlaces": [
  {
    "title": "Phoenix Marketcity",
    "description": "Phoenix Marketcity is one of the largest shopping malls in Pune located in Viman Nagar. Travelers using Cab Service in Viman Nagar from SRS Cab Service often visit for shopping, dining, and entertainment."
  },
  {
    "title": "Pune Airport",
    "description": "Pune Airport is located close to Viman Nagar and is a major travel hub. Visitors using SRS Cab Service frequently rely on timely cab services for airport transfers."
  },
  {
    "title": "Symbiosis International University",
    "description": "Symbiosis International University is a prominent educational institution in Viman Nagar. Travelers using SRS Cab Service often commute here for academic and official purposes."
  },
  {
    "title": "Jogger’s Park",
    "description": "Jogger’s Park in Viman Nagar is a peaceful green space ideal for walking and relaxation. Visitors using SRS Cab Service often visit this park for leisure time."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a historic landmark located near Viman Nagar. Travelers using SRS Cab Service often explore its gardens and museum exhibits."
  },
  {
    "title": "Koregaon Park",
    "description": "Koregaon Park is a vibrant neighborhood known for cafes and nightlife. Visitors using SRS Cab Service often travel here for dining and entertainment."
  },
  {
    "title": "Bund Garden",
    "description": "Bund Garden is a scenic riverside spot near Viman Nagar. Travelers using SRS Cab Service often relax here and enjoy the greenery."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Dagdusheth Halwai Ganpati Temple is a famous religious site in Pune. Visitors using SRS Cab Service often visit to seek blessings and spiritual peace."
  },
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is a historic fort and a major tourist attraction in Pune. Travelers using SRS Cab Service often explore this landmark to learn about the city’s history."
  },
  {
    "title": "Osho Garden",
    "description": "Osho Garden is a serene and beautifully maintained garden near Viman Nagar. Visitors using SRS Cab Service often visit for relaxation and peaceful surroundings."
  }
],



services: [
{
name: "Taxi Service Viman Nagar",
description: "Taxi service Viman Nagar offers reliable transportation for local and airport travel. Customers can book taxis for daily and outstation trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services in Viman Nagar."
},
{
name: "Taxi Service in Wadgaon Sheri",
description: "Taxi service in Wadgaon Sheri provides convenient travel for city and airport routes. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Cabs Booking in Chandan Nagar",
description: "Cabs booking in Chandan Nagar offers quick and easy reservation options. Customers can book cabs online or via phone. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily in Chandan Nagar."
},
{
name: "Taxi Booking in Kalyani Nagar",
description: "Taxi booking in Kalyani Nagar provides fast and reliable booking options. Customers can reserve taxis for local and outstation trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your taxi easily."
},
{
name: "Taxi Service in Koregaon Park",
description: "Taxi service in Koregaon Park offers premium transportation for city and nightlife travel. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Taxi Service in Pune Airport",
description: "Taxi service in Pune airport provides reliable pickup and drop services. Customers can book taxis for timely airport transfers. Professional drivers ensure punctual journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport taxi services."
},
{
name: "Innova Crysta on Rent in Viman Nagar",
description: "Innova Crysta on rent in Viman Nagar offers premium SUV travel for families and groups. Customers can enjoy spacious seating and comfort. Professional drivers ensure safe journeys. Ideal for outstation travel. Transparent pricing ensures value for money. Travel comfortably with Innova Crysta."
},
{
name: "Ertiga on Rent in Viman Nagar",
description: "Ertiga on rent in Viman Nagar provides comfortable 7 seater travel for families. Customers can book vehicles for local and outstation trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Ertiga services."
},
{
name: "Tempo Traveller Hire in Viman Nagar",
description: "Tempo traveller hire in Viman Nagar offers group travel solutions for tours and events. Customers can book spacious vehicles for family trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with tempo traveller services."
},
{
name: "Mini Bus on Rent in Viman Nagar",
description: "Mini bus on rent in Viman Nagar provides large group travel solutions. Customers can book buses for corporate and family trips. Professional drivers ensure safe journeys. Spacious seating enhances experience. Flexible booking options are available. Travel easily with mini bus services."
},
{
name: "Sedan Cab Hire for Outstation in Viman Nagar",
description: "Sedan cab hire for outstation in Viman Nagar offers affordable travel for long-distance trips. Customers can book vehicles for budget-friendly journeys. Professional drivers ensure safe travel. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with sedan cab services."
},
{
name: "Innova Cabs on Rent in Viman Nagar",
description: "Innova cabs on rent in Viman Nagar provide comfortable travel for families and groups. Customers can book vehicles for long-distance journeys. Professional drivers ensure safe travel. Spacious seating enhances experience. Flexible booking options are available. Travel easily with Innova cab services."
},
{
name: "Viman Nagar to Shirdi Cab Services",
description: "Viman Nagar to Shirdi cab services offer convenient travel for temple visits. Customers can book cabs for pilgrimage trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily to Shirdi with cab services."
},
{
name: "Cab Service in Yerwada",
description: "Cab service in Yerwada provides reliable transportation for city and airport travel. Customers can book cabs for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Cab Booking Viman Nagar",
description: "Cab booking Viman Nagar offers quick reservation options for travelers. Customers can book cabs online or offline. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily in Viman Nagar."
},
{
name: "Taxi Booking Viman Nagar",
description: "Taxi booking Viman Nagar provides easy booking options for customers. Travelers can reserve taxis instantly for daily and airport trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your taxi easily."
},
{
name: "Cab Near Viman Nagar",
description: "Cab near Viman Nagar offers nearby booking options for quick travel. Customers can find cabs easily for instant rides. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book cabs easily near Viman Nagar."
},
{
name: "Taxi Near Viman Nagar",
description: "Taxi near Viman Nagar provides convenient transportation for local travel. Customers can book taxis quickly for daily rides. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with nearby taxi services."
},
{
name: "Best Cab Service in Viman Nagar",
description: "Best cab service in Viman Nagar offers top-rated transportation for customers. Travelers can enjoy high-quality service and comfort. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with best cab services."
},
{
name: "Cheap Cab Service Viman Nagar",
description: "Cheap cab service Viman Nagar provides budget-friendly transportation for daily travel. Customers can book cabs at affordable rates. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with cheap cab services."
},
{
name: "Affordable Cab Service Viman Nagar",
description: "Affordable cab service Viman Nagar offers cost-effective travel for local and outstation trips. Customers can book cabs at competitive prices. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with affordable cab services."
},
{
name: "Viman Nagar Cab Hire",
description: "Viman Nagar cab hire provides flexible vehicle options for personal and business travel. Customers can hire cabs for local and outstation journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Hire cabs easily in Viman Nagar."
}
],

tableData: [
["Taxi Service Viman Nagar","Taxi Service in Wadgaon Sheri"],
["Cabs Booking in Chandan Nagar","Taxi Booking in Kalyani Nagar"],
["Taxi Service in Koregaon Park","Taxi Service in Pune Airport"],
["Innova Crysta on Rent in Viman Nagar","Ertiga on Rent in Viman Nagar"],
["Tempo Traveller Hire in Viman Nagar","Mini Bus on Rent in Viman Nagar"],
["Sedan Cab Hire for Outstation in Viman Nagar","Innova Cabs on Rent in Viman Nagar"],
["Viman Nagar to Shirdi Cab Services","Cab Service in Yerwada"],
["Cab Booking Viman Nagar","Taxi Booking Viman Nagar"],
["Cab Near Viman Nagar","Taxi Near Viman Nagar"],
["Best Cab Service in Viman Nagar","Cheap Cab Service Viman Nagar"],
["Affordable Cab Service Viman Nagar","Viman Nagar Cab Hire"]
],



whychoose: [
  {
    WhyChooseheading: "Prime Location Service in Viman Nagar",
    WhyChoosedescription: "SRS Cab Service provides reliable cab service in Viman Nagar with drivers familiar with key areas like Pune Airport, Phoenix Marketcity, and nearby IT hubs."
  },
  {
    WhyChooseheading: "Affordable Cab Service in Viman Nagar",
    WhyChoosedescription: "We offer budget-friendly cab services in Viman Nagar with transparent pricing. Customers receive clear fare details without hidden charges."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "SRS Cab Service operates 24/7 in Viman Nagar, making it convenient for airport transfers, office commutes, and late-night travel."
  },
  {
    WhyChooseheading: "Comfortable & AC Vehicles",
    WhyChoosedescription: "Our fleet includes clean, well-maintained, and air-conditioned vehicles to ensure a smooth and comfortable ride within Viman Nagar and across Pune."
  },
  {
    WhyChooseheading: "Multiple Cab Options",
    WhyChoosedescription: "Choose from hatchbacks, sedans, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for local and outstation travel."
  },
  {
    WhyChooseheading: "Fast Airport Pickup & Drop",
    WhyChoosedescription: "We provide quick pickup and drop services to Pune Airport from Viman Nagar, making travel easy for frequent flyers."
  },
  {
    WhyChooseheading: "Safe & Professional Drivers",
    WhyChoosedescription: "Our trained drivers ensure safe driving, polite service, and a hassle-free travel experience for every ride."
  },
  {
    WhyChooseheading: "Trusted Cab Service in Viman Nagar Pune",
    WhyChoosedescription: "SRS Cab Service is trusted by residents and travelers for punctual, reliable, and affordable cab service in Viman Nagar."
  }
]
}

const faqData = [
  { question: "Do you provide cab service in Viman Nagar?", answer: "Yes, SRS Cab Service offers reliable cab services in Viman Nagar for local and outstation travel." },
  { question: "Is cab service available in Viman Nagar 24 hours?", answer: "Yes, our cab service operates 24/7 for all travel needs." },
  { question: "Do you provide airport cab service from Viman Nagar?", answer: "Yes, we provide fast Pune Airport pickup and drop services from Viman Nagar." },
  { question: "Which areas do you cover near Viman Nagar?", answer: "We cover Kharadi, Lohegaon, Dhanori, Wagholi, and nearby areas." },
  { question: "Which vehicles are available?", answer: "We offer hatchbacks, sedans, SUVs, Innova Crysta, and Tempo Travellers." },
  { question: "Can I book cab online in Viman Nagar?", answer: "Yes, you can easily book cab service online or via phone." },
  { question: "Do you provide one-way cab service?", answer: "Yes, we provide one-way and round-trip cab services from Viman Nagar." },
  { question: "Are drivers professional?", answer: "Yes, all drivers are trained, experienced, and professional." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all vehicles are regularly cleaned and sanitized for safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Nikhil Sharma",
    feedback:
      "Booked cab from Viman Nagar to airport. Very fast pickup and smooth ride.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Pooja Deshmukh",
    feedback:
      "Best cab service in Viman Nagar. Clean car, polite driver, and on-time service.",
    rating: 5
  }
];




























const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "SRS Cab - Viman Nagar Cab Service",
  "description": "Reliable cab service in Viman Nagar, Pune with SRS Cab. Book taxis for local travel, airport transfers, and outstation trips. 24/7 service with Innova, Ertiga, sedan, tempo traveller, and mini bus options.",
  "image": "https://www.srscabservice.com/logo.png",
  "telephone": "+91 9011955415",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Viman Nagar",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411014",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "18.5660",
    "longitude": "73.9135"
  },
  "url": "https://www.srscabservice.com/viman-nagar-cab-service",
  "priceRange": "₹₹",
  "openingHours": "Mo-Su 00:00-23:59",
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "bestRating": "5",
    "worstRating": "1",
    "ratingCount": "1475"
  },
  "areaServed": {
    "@type": "City",
    "name": "Viman Nagar, Pune"
  }
};








  return (
    <div>
      <Helmet>
  <title>Cab Service in Viman Nagar | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Book reliable cab service in Viman Nagar, Pune with SRS Cab. Local rides, airport transfers, and outstation trips available 24/7. Innova, Ertiga, sedan, tempo traveller, and mini bus options." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>




 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/50.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceinvimannagar;